import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import update from 'react-addons-update';
import {push} from 'react-router-redux';
import Color from 'color';
import queryString from 'query-string';
import {Button} from 'rmwc';

import * as styles from '../../styles';
import {renderExaminationPage, getItems} from '../examination/render';
import {setSelectedItems} from '../tree/actions';
import Dialog from '../../dialog/dialog';
import {request} from '../../containers/actions';
import {addToCart} from '../cart/actions';
import {imageUrl} from '../../utilities/requests';
import Folder from '../book/folder';
import Content from '../../content-manager/content';
import CommentList from '../../social/comment';
import tinyMCEConfig from '../../utilities/tinymce_config';
import { resizer1100, resizer600, resizer800 } from '../../responsiver'; 


//@Radium
export default class ExaminationCatalogue extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static propTypes = {
        height: PropTypes.number,
    }

    static defaultProps = {
        height: 29,
    }

    initialState = {
        data: {examination: []},
        currentPage: 0,
        view: 0,
        index: 1,
        dialog: false,
        hoverBook: false
    }

    state = _.clone(this.initialState)

    constructor(props, context) {
        super(props, context);
        this.fullscreenChanged = this.fullscreenChanged.bind(this); 
    }

    getTab(props) {
        return props.tab || ( props !== null && props.params !=null && props.params.tab);
    }

    async componentDidMount() {
        if (this.props.params.catalogueId === '0') {
            return;
        }
        if (this.props.params.examinationId === undefined) {
            const path = this.context.store.getState().getIn(
                ['routing', 'locationBeforeTransitions', 'pathname'],
            );
            this.context.store.dispatch(push(path + '0/introduction/'));
        }
        if (this.props.params.examinationId && this.getTab(this.props) === undefined) {
            const path = this.context.store.getState().getIn(
                ['routing', 'locationBeforeTransitions', 'pathname'],
            );
            this.context.store.dispatch(push(path + 'introduction/'));
        }
        document.addEventListener('webkitfullscreenchange', this.fullscreenChanged, false);
        document.addEventListener('mozfullscreenchange', this.fullscreenChanged, false);
        document.addEventListener('fullscreenchange', this.fullscreenChanged, false);
        document.addEventListener('MSFullscreenChange', this.fullscreenChanged, false);
        await this.fetch.bind(this)();

        const index = this.props.params.examinationId === '0' ? null : _.findIndex( 
            this.state.data.examinations,
            examination => examination.id === Number(this.props.params.examinationId),
        );
        const item = index === null || index === -1 ? this.state.data : this.state.data.examinations[index];
        if (this.getTab(this.props) === 'booklet' && !_.isArray(item.questions)) {
            const examination = await this.context.store.dispatch(request({ 
                path: `/examination/${item.id}/?detailed&all&react__route=${window.location.pathname}`,
            }));
            this.setState(update(this.state, {data: {examinations: {$splice: [[index, 1, examination]]}}}));
        }
        if (this.getTab(this.props) === 'top_ranks' && !item.topRanks) {
            const topRanks = await this.context.store.dispatch(request({
                path: `/examination/${item.id}/top_ranks/`,
            }));
            const updatedExamination = update(item, {topRanks: {$set: topRanks}});
            this.setState(update(this.state, {data: {examinations: {$splice: [[index, 1, updatedExamination]]}}}));
        }
        if (_.includes(['results'], this.getTab(this.props)) && !this.props.children) {
            const path = this.context.store.getState().getIn(
                ['routing', 'locationBeforeTransitions', 'pathname'],
            );
            this.context.store.dispatch(push(path + '-/'));
        }
    }

    componentWillUnmount() {
        if (this.timeoutId)
            clearTimeout(this.timeoutId);
        document.removeEventListener('webkitfullscreenchange', this.fullscreenChanged, false);
        document.removeEventListener('mozfullscreenchange', this.fullscreenChanged, false);
        document.removeEventListener('fullscreenchange', this.fullscreenChanged, false);
        document.removeEventListener('MSFullscreenChange', this.fullscreenChanged, false);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.params.catalogueId !== nextProps.params.catalogueId) {
            this.setState(this.initialState);
        }
    }

    async componentDidUpdate(prevProps) {
        if (this.props.params.catalogueId === '0') {
            return;
        }
        if (!this.timeoutId && !this.state.initialized && this.props.params.examinationId && this.state.data.id) {
            _.forEach(new Array(this.state.data.examinations.length + 1), (__, index) =>
                window.getComputedStyle(this.refs[`examination-${index}`]).getPropertyValue('display'));
            this.timeoutId = setTimeout(() => {
                this.setState({initialized: true});
                this.timeoutId = undefined;
            }, 1500);
        }
        if (
            (this.props.params.catalogueId !== prevProps.params.catalogueId || this.props.params.examinationId !== prevProps.params.examinationId)
            && this.props.params.examinationId === undefined
        ) {
            const path = this.context.store.getState().getIn(
                ['routing', 'locationBeforeTransitions', 'pathname'],
            );
            this.context.store.dispatch(push(path + '0/introduction/'));
        }
        if (this.getTab(this.props) !== this.getTab(prevProps) && this.props.params.examinationId && this.getTab(this.props) === undefined) {
            const path = this.context.store.getState().getIn(
                ['routing', 'locationBeforeTransitions', 'pathname'],
            );
            this.context.store.dispatch(push(path + 'introduction/'));
        }
        if (this.getTab(this.props) !== this.getTab(prevProps) && this.getTab(this.props) === 'about_compiler') {
            this.setState({compilersInitialized: false});
            setTimeout(() => this.setState({compilersInitialized: true}), 300);
        }
        if (this.props.params.catalogueId !== prevProps.params.catalogueId) {
            await this.fetch.bind(this)();
        }

        const index = this.props.params.examinationId === '0' ? null : _.findIndex(
            this.state.data.examinations,
            examination => examination.id === Number(this.props.params.examinationId),
        );
        const item = index === null || index === -1 ? this.state.data : this.state.data.examinations[index];
        if (
            this.getTab(this.props) !== this.getTab(prevProps) &&
            _.includes(['virtual_content', 'reports', 'budgets'], this.getTab(this.props))
        ) {
            const folder = _.find(item.folders, folder => folder.title === this.getTab(this.props));
            if (!folder) {
                const response = await this.context.store.dispatch(request({
                    path: index === null
                        ? `/examination-catalogue/${item.id}/create_folder/`
                        : `/examination/${item.id}/create_folder/`,
                    body: {title: this.getTab(this.props)},
                    method: 'POST',
                }));
                if (index === null)
                    this.setState(update(this.state, {data: {folders: {$push: [response]}}}));
                else {
                    const updatedItem = update(item, {folders: {
                        $push: [response],
                    }});
                    this.setState(update(this.state, {data: {examinations: {$splice: [[index, 1, updatedItem]]}}}));
                }
            }
        }
        if (this.getTab(this.props) !== this.getTab(prevProps) && this.getTab(this.props) === 'booklet' && !_.isArray(item.questions)) {
            const examination = await this.context.store.dispatch(request({
                path: `/examination/${item.id}/?detailed&all&react__route=${window.location.pathname}`,
            }));
            this.setState(update(this.state, {data: {examinations: {$splice: [[index, 1, examination]]}}}));
        }
        if (this.getTab(this.props) !== this.getTab(prevProps) && this.getTab(this.props) === 'top_ranks' && !item.topRanks) {
            const topRanks = await this.context.store.dispatch(request({
                path: `/examination/${item.id}/top_ranks/`,
            }));
            const updatedExamination = update(item, {topRanks: {$set: topRanks}});
            this.setState(update(this.state, {data: {examinations: {$splice: [[index, 1, updatedExamination]]}}}));
        }
        if (
            this.getTab(this.props) !== this.getTab(prevProps) &&
            _.includes(['results'], this.getTab(this.props)) &&
            !this.props.children
        ) {
            const path = this.context.store.getState().getIn(
                ['routing', 'locationBeforeTransitions', 'pathname'],
            );
            this.context.store.dispatch(push(path + '-/'));
        }
        if (this.props.params.examinationId !== prevProps.params.examinationId) {
            if (this.context.user.hasPerm('examination.edit')) {
                if (!prevProps.params.examinationId || prevProps.params.examinationId === '0') {
                    this.setState(update(this.state, {data: {compilers: {
                        $set: this.props.store.getIn(['compilersTree', 'selected']).map((__, item) => Number.parseInt(item)).toArray(),
                    }}}));
                }
                else {
                    const index = _.findIndex(this.state.data.examinations, examination => examination.id === Number(prevProps.params.examinationId));
                    const prevExamination = index === -1 ? null : this.state.data.examinations[index];
                    if (prevExamination && !_.isEqual(
                        prevExamination.compilers,
                        this.props.store.getIn(['compilersTree', 'selected']).map((__, item) => Number.parseInt(item)).toArray(),
                    )) {
                        const updatedExamination = update(prevExamination, {
                            compilers: {$set: this.props.store.getIn(['compilersTree', 'selected']).map((__, item) => Number.parseInt(item)).toArray()},
                            modified: {$set: true},
                        });
                        this.setState(update(this.state, {data: {examinations: {
                            $splice: [[index, 1, updatedExamination]],
                        }}}));
                    }
                }
                if (this.props.params.examinationId) {
                    if (this.props.params.examinationId === '0') {
                        this.context.store.dispatch(setSelectedItems(
                            _.map(this.state.data.compilers, item => item),
                            'compiler',
                            this.props.store.getIn(['compilersTree', 'elementId']),
                        ));
                    }
                    else {
                        const index = _.findIndex(this.state.data.examinations, examination => examination.id === Number(this.props.params.examinationId));
                        const currentExamination = index === -1 ? null : this.state.data.examinations[index];
                        this.context.store.dispatch(setSelectedItems(
                            _.map(currentExamination.compilers, item => item),
                            'compiler',
                            this.props.store.getIn(['compilersTree', 'elementId']),
                        ));
                    }
                }
            }
        }
    }

    fullscreenChanged() {
        this.setState({fullscreen: document.fullScreen || document.webkitIsFullScreen || document.mozFullScreen});
    }

    imageSource(image, width) {
        if (image) {
            if (_.isString(image))
                return imageUrl(image, {
                    width: width || Number.parseInt(16 * 77 * 3 / 10),
                    type: 'contain',
                });
            else
                return image.data;
        }
        else
            return '';
    }

    fileSource(file) {
        if (file) {
            if (_.isString(file))
                return `/file/${file}?inline=1&type=${encodeURIComponent('application/pdf')}`;
            else
                return file.data;
        }
        else
            return '';
    }

    async save() {
        try {
            const modifiedExaminations = _.filter(
                this.state.data.examinations,
                examination => examination.modified,
            );
            if (modifiedExaminations.length)
                await this.context.store.dispatch(request({
                    path: '/examination/',
                    body: window.toFormData(_.map(
                        modifiedExaminations,
                        examination => ({
                            id: examination.id,
                            color: examination.color,
                            preparation_examination: examination.preparation_examination || '\0',
                            cover_photo: examination?.cover_photo?.file,
                        }),
                    )),
                    method: 'PATCH',
                }));
            const id = this.state.data.id;
            const payload = {
                ..._.pickBy(this.state.data, (__, key) => key !== 'folders'),
                cover_photo: this.state.data.cover_photo.file,
                examinations: undefined,
            };
            const response = await this.context.store.dispatch(request({
                path: `/examination-catalogue/${id}/`,
                body: window.toFormData(payload),
                method: 'PATCH',
            }));
            this.setState({data: {...response, examinations: this.state.data.examinations}, initialized: false});
            return true;
        }
        catch (exception) {
            console.log(exception)
            return false;
        }
    }

    async fetch() {
        this.setState(this.initialState);
        const response = await this.context.store.dispatch(request({
            path: `/examination-catalogue/${this.props.params.catalogueId}/`,
        }));
        const now = new window.MomentJalali();
        if (now.jMonth() < 5)
            now.add(-1, 'jYear');
        now.jMonth(5);
        now.startOf('jMonth');
        // let currentYear = (Math.floor(now.toDate().getTime() / 1000));
        let currentYear = (now.toDate().getTime() / 1000 + 12600 );
        now.add(1, 'jYear');
        // currentYear += ',' + (Math.floor(now.toDate().getTime() / 1000));
        currentYear += ',' + (now.toDate().getTime() / 1000 + 12600) ;

        const examinations = (await this.context.store.dispatch(request({
            path: '/examination/?' + queryString.stringify({
                examination_type: response.examination_type.id,
                grades: response.grade.id,
                date__range: currentYear,
                all: '',
                o: 'id',
                public: 1,
                limit: 14,
                react__route : window.location.pathname,
            }),
        },null,0,this.onDone.bind(this),this.onError.bind(this)))).results;
        await new Promise(resolve => this.setState({data: {...response, examinations}, initialized: false}, resolve));
    }

    onDone()
    {  
    }
    onError()
    { 
        this.context.store.dispatch(push('/azmuns?dialog=login')); 
    }
    addFile(folderUUID, file) {
        const index = this.props.params.examinationId === '0' ? null : _.findIndex(
            this.state.data.examinations,
            examination => examination.id === Number(this.props.params.examinationId),
        );
        const item = index === null ? this.state.data : this.state.data.examinations[index];
        const folderIndex = _.findIndex(item.folders, folder => folder.uuid === folderUUID);
        const updatedFolder = update(item.folders[folderIndex], {files: {
            $push: [file],
        }});
        if (index === null)
            this.setState(update(this.state, {data: {folders: {
                $splice: [[index, 1, updatedFolder]],
            }}}));
        else {
            const updatedItem = update(this.state.data.examinations[index], {folders: {
                $splice: [[folderIndex, 1, updatedFolder]],
            }});
            this.setState(update(this.state, {data: {examinations: {
                $splice: [[index, 1, updatedItem]],
            }}}));
        }
    }

    updateFile(folderUUID, file) {
        const index = this.props.params.examinationId === '0' ? null : _.findIndex(
            this.state.data.examinations,
            examination => examination.id === Number(this.props.params.examinationId),
        );
        const item = index === null ? this.state.data : this.state.data.examinations[index];
        const folderIndex = _.findIndex(item.folders, folder => folder.uuid === folderUUID);
        const fileIndex = _.findIndex(item.folders[folderIndex].files, file_ => file_.uuid === file.uuid);
        const updatedFolder = update(item.folders[folderIndex], {files: {
            $splice: [[fileIndex, 1, file]],
        }});
        if (index === null)
            this.setState(update(this.state, {data: {folders: {
                $splice: [[index, 1, updatedFolder]],
            }}}));
        else {
            const updatedItem = update(this.state.data.examinations[index], {folders: {
                $splice: [[folderIndex, 1, updatedFolder]],
            }});
            this.setState(update(this.state, {data: {examinations: {
                $splice: [[index, 1, updatedItem]],
            }}}));
        }
    }

    removeFile(folderUUID, fileUUID) {
        const index = this.props.params.examinationId === '0' ? null : _.findIndex(
            this.state.data.examinations,
            examination => examination.id === Number(this.props.params.examinationId),
        );
        const item = index === null ? this.state.data : this.state.data.examinations[index];
        const folderIndex = _.findIndex(item.folders, folder => folder.uuid === folderUUID);
        const fileIndex = _.findIndex(item.folders[folderIndex].files, file_ => file_.uuid === fileUUID);
        const updatedFolder = update(item.folders[folderIndex], {files: {
            $splice: [[fileIndex, 1]],
        }});
        if (index === null)
            this.setState(update(this.state, {data: {folders: {
                $splice: [[index, 1, updatedFolder]],
            }}}));
        else {
            const updatedItem = update(this.state.data.examinations[index], {folders: {
                $splice: [[folderIndex, 1, updatedFolder]],
            }});
            this.setState(update(this.state, {data: {examinations: {
                $splice: [[index, 1, updatedItem]],
            }}}));
        }
    }

    render() {
        if (this.props.params.catalogueId === '0') {
            return <div>{window.gettext('Books')}</div>;
        }
        if (!this.props.params.examinationId || !this.state.data.id)
            return null;
        const index = _.findIndex(this.state.data.examinations, examination => examination.id === Number(this.props.params.examinationId));
        const currentExamination = index === -1 ? null : this.state.data.examinations[index];
        const pages = currentExamination
            ? _.max(_.map(getItems(currentExamination, this.state.view), item => item.page) || 0) + 1
            : null;
        return <span style={resizer1100}>
            {this.context.user.hasPerm('examination.edit') 
                ? <div style={{position: 'relative'}}>
                    <div
                        style={{
                            display: 'flex',
                            alignContent: 'center',
                            justifyContent: 'center',
                            fontWeight: '500',
                            fontSize: '1.4em',
                        }}>
                        <div>
                            {this.state.data
                                ? this.state.data.title
                                : null
                            }
                        </div>
                    </div>
                    <div style={{position: 'absolute', width: '100%', top: '0'}}>
                        <div
                            style={{
                                // ...styles.buttonContainer,
                                float: 'left',
                                marginRight: '.5em',
                            }}>
                            <button
                                key='save'
                                style={{...styles.defaultButton, marginRight: '.5em'}}
                                onClick={async () => {
                                    if (!window.confirm(window.gettext('Are you sure you wanna save this catalogue?')))
                                        return;
                                    if (!(await this.save.bind(this)()))
                                        alert(window.gettext('Failed to save'));
                                }}>
                                {window.gettext('Apply')}
                            </button>
                        </div>
                    </div>
                </div>
                : null
            }
            
            <div style={{width: '100%', display: 'inline-block', paddingTop: '3em'}}>
                <input
                    type='file'
                    ref='fileSelector'
                    style={{display: 'none'}}
                    multiple
                    onClick={() => {
                        this.refs.fileSelector.value = '';
                    }}
                    onChange={async () => {
                        const file = this.refs.fileSelector.files[0];
                        const data = await window.readFile(file, 'base64');
                        if (this.refs.fileSelector.dataset.target === 'cover') {
                            if (this.props.params.examinationId === '0')
                                this.setState(update(this.state, {data: {
                                    cover_photo: {$set: {data, file}},
                                }}));
                            else {
                                const index = _.findIndex(
                                    this.state.data.examinations,
                                    examination => examination.id === Number(this.props.params.examinationId),
                                );
                                const updatedExamination = update(this.state.data.examinations[index], {
                                    cover_photo: {$set: {data, file}},
                                    modified: {$set: true},
                                });
                                this.setState(update(this.state, {data: {examinations: {
                                    $splice: [[index, 1, updatedExamination]],
                                }}}));
                            }
                        }
                    }}
                />
                <div
                    key='cover'
                    style={{
                        width: '21.5em',
                        float: 'right',
                        position: 'relative',
                        ':hover': {
                            position: 'relative',
                        },
                    }}>
                    <div
                        key='examinations'
                        style={{
                            position: 'absolute',
                            left: '0',
                            width: '10em',
                            transition: 'width 400ms',
                            ':hover': {
                                opacity: '1',
                            },
                        }}>
                        <div onMouseEnter={(e)=>this.setState(e=>{
                            return{
                                ...e,
                                hoverBook: true
                            }
                        })} 
                            onMouseLeave={(e)=>this.setState(e=>({
                                    hoverBook: false}))
                            }
                            
                            style={{width: '10em', direction: 'ltr'}}>
                            {_.map(
                                [
                                    {
                                        id: 0,
                                        title: this.state.data
                                            ? this.state.data.title
                                            : window.gettext('Introduction'),
                                        color: this.state.data.color,
                                    },
                                    ..._.sortBy(this.state.data.examinations, 'level.id'),
                                ],
                                (examination, index) => <button
                                    key={'examination-' + index}
                                    ref={'examination-' + index}
                                    style={{
                                        ...(Number(this.props.params.examinationId) === examination.id
                                            ? {
                                                ..._.pickBy(styles.activeButton, (__, key) => key !== 'borderRadius'),
                                                backgroundColor: examination.color
                                                    ? examination.color
                                                    : styles.activeButton.backgroundColor,
                                                width: '100%',
                                            }
                                            : {
                                                ..._.pickBy(styles.button, (__, key) => key !== 'borderRadius'),
                                                backgroundColor: examination.color || '#9a9a9a',
                                                opacity: Radium.getState(this.state, 'cover', ':hover') ||
                                                !this.state.initialized ||
                                                Number(this.props.params.examinationId) === examination.id ||
                                                window.mobile
                                                    ? '1'
                                                    : '.8',
                                                width: this.state.hoverBook ||
                                                !this.state.initialized || window.mobile
                                                    ? '100%'
                                                    : `${1 / .9}em`,
                                            }),
                                        minWidth: undefined,
                                        color: 'white',
                                        display: 'block',
                                        position: 'relative',
                                        direction: 'rtl',
                                        ':focus': undefined,
                                        marginTop: '.5em',
                                        borderTopLeftRadius: '.35em',
                                        borderBottomLeftRadius: '.35em',
                                        overflow: 'hidden',
                                        transition: `width 600ms ${index * 50}ms`,
                                        padding: '0.8em !important',
                                    }}
                                    onClick={() => {
                                        this.context.store.dispatch(push(`/examination-catalogue/${this.props.params.catalogueId}/${examination.id}/introduction/`));
                                    }}>
                                    {this.state.hoverBook && this.context.user.hasPerm('examination.edit')
                                        ? <div
                                            style={{
                                                position: 'absolute',
                                                top: '.5em',
                                                right: '.5em',
                                                width: '5em',
                                            }}>
                                            <i
                                                key='color'
                                                style={{float: 'right', marginRight: '.25em'}}
                                                className='fa-paint-brush'
                                                onClick={event => {
                                                    event.stopPropagation();
                                                    const color = prompt(
                                                        window.gettext('Enter examination color') + ':',
                                                        examination.color || '',
                                                    );
                                                    if (color === null)
                                                        return;
                                                    if (examination.id === 0) {
                                                        this.setState(update(this.state, {data: {
                                                            color: {$set: color},
                                                        }}));
                                                    }
                                                    else {
                                                        const index = _.findIndex(
                                                            this.state.data.examinations,
                                                            examination_ => examination_.id === examination.id,
                                                        );
                                                        const updatedExamination = update(this.state.data.examinations[index], {
                                                            color: {$set: color},
                                                            modified: {$set: true},
                                                        });
                                                        this.setState(update(this.state, {data: {examinations: {
                                                            $splice: [[index, 1, updatedExamination]],
                                                        }}}));
                                                    }
                                                }}>
                                            </i>
                                        </div>
                                        : null
                                    }
                                    <div style={{overflow: 'hidden', marginLeft: '.4em'}}>
                                        <div style={{width: `${9 / .9}em`}}>
                                            {examination.title}
                                        </div>
                                    </div>
                                </button>,
                            )}
                        </div>
                    </div>
                    <img
                        style={{
                            display: 'block',
                            width: `${this.props.height / 29.7 * 21}em`,
                            height: `${this.props.height}em`,
                            objectFit: 'cover',
                            cursor: this.context.user.hasPerm('examination.edit') ? 'pointer' : undefined,
                            marginLeft: '.75em',
                            marginRight: '.25em',
                            marginBottom: '.25em',
                            boxShadow: '0 6px 6px 0 rgba(119,119,119,0.75)',
                            borderRadius: '6px',
                        }}
                        src={currentExamination
                            ? this.imageSource.bind(this)(_.find(
                                this.state.data.examinations,
                                examination => examination.id === Number(this.props.params.examinationId),
                            ).cover_photo)
                            : this.imageSource.bind(this)(this.state.data.cover_photo)
                        }
                        onClick={() => {
                            if (!this.context.user.hasPerm('examination.edit'))
                                return;
                            this.refs.fileSelector.accept = 'image/*';
                            this.refs.fileSelector.dataset.target = 'cover';
                            this.refs.fileSelector.click();
                        }}
                        onError={({target}) => {
                            if (currentExamination && target.src !== this.imageSource.bind(this)(this.state.data.cover_photo))
                                target.src = this.imageSource.bind(this)(this.state.data.cover_photo);
                            else
                                target.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
                        }}
                    />
                    {currentExamination && currentExamination.unrestricted_store_item && currentExamination.unrestricted_store_item.off
                        ? <div
                            style={{
                                position: 'absolute',
                                top: '0',
                                right: '0',
                                width: `${this.props.height / 29.7 * 21}em`,
                                height: `${this.props.height}em`,
                                marginRight: '.25em',
                                marginBottom: '.25em',
                                boxShadow: '0 6px 6px 0 rgba(119,119,119,0.75)',
                                borderRadius: '6px',
                                overflow: 'hidden',
                                pointerEvents: 'none'
                            }}>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '0',
                                    right: '0',
                                    transform: 'translateX(50%) rotate(45deg)',
                                    transformOrigin: '50% 0',
                                    width: '10em',
                                    height: '5em',
                                    backgroundColor: 'red',
                                    textAlign: 'center',
                                    paddingTop: '1.5em',
                                    color: 'white',
                                    lineHeight: '1.5em',
                                    boxSizing: 'border-box',
                                }}>
                                <span style={{fontSize: '1.3em', fontWeight: '800'}}>
                                    {'%' + currentExamination.unrestricted_store_item.off.persian()}
                                    <br/>
                                    {window.gettext('Off')}
                                </span>
                            </div>
                        </div>
                        : null
                    }
                    {currentExamination && currentExamination.unrestricted_store_item
                        ? <div style={{top: 'calc(100% + 1.25em)', right: '1.25em', textAlign: 'center'}}>
                            <i
                                key='shop'
                                style={{
                                    cursor: 'pointer',
                                    color: styles.successColor,
                                    ':hover': {
                                        color: new Color(styles.successColor).darken(.2),
                                    },
                                }}
                                className='fa-shopping-cart fa-3x'
                                onClick={() => {
                                    this.context.store.dispatch(addToCart({
                                        item: currentExamination.unrestricted_store_item,
                                        count: 1,
                                    }));
                                }}>
                            </i>
                            <br/>
                            <span>
                                {window.gettext('Add to Card')}
                            </span>
                            <br/>
                            <span>
                                {window.gettext('Price')}:&nbsp;
                                <span style={{display: 'inline-block', position: 'relative'}}>
                                    {(currentExamination.unrestricted_store_item.price || '-').persian()} {window.gettext('Tooman')}
                                    {currentExamination.unrestricted_store_item.off
                                        ? <>
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '40%',
                                                    left: '0',
                                                    width: '100%',
                                                    height: '.14em',
                                                    backgroundColor: 'red',
                                                    transformOrigin: '50% 50%',
                                                    transform: 'rotate(-10deg)',
                                                }}
                                            />
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '-.7em',
                                                    left: '-50%',
                                                    color: 'red',
                                                    transformOrigin: '50% 50%',
                                                    transform: 'rotate(-3deg)',
                                                    fontWeight: '800',
                                                    fontSize: '1.4em',
                                                }}>
                                                {(
                                                    currentExamination.unrestricted_store_item.price -
                                                     (currentExamination.unrestricted_store_item.price *  currentExamination.unrestricted_store_item.off /100) 
                                                ).persian()}
                                                &nbsp;
                                                {window.gettext('Tooman')}
                                            </div>
                                        </>
                                        : null
                                    }
                                </span>
                            </span>
                        </div>
                        : null
                    }
                </div>
                <div style={{width: 'calc(100% - 21.5em)', height: `${this.props.height}em`, float: 'left'}}>
                    <div
                        style={this.state.fullscreen
                            ? {
                                padding: '2em',
                                width: '100%',
                                height: '100%',
                                boxSizing: 'border-box',
                                position: 'relative',
                                overflow: 'auto',
                                backgroundColor: 'white'
                            }
                            : {
                                paddingRight: '.5em',
                                height: '100%',
                                position: 'relative',
                                width: '100%',
                            }
                        }
                        ref='content'>
                        <button
                            style={{
                                ...styles.button,
                                minWidth: undefined,
                                float: 'right',
                                width: '2.7em',
                                height: '2.7em',
                                marginLeft: '.5em',
                                marginRight: '.5em',
                                position: 'absolute',
                                top: this.state.fullscreen ? '.5em' : 'calc(100% + 1.2em)',
                                left: '.5em',
                                zIndex: '1',
                            }}
                            onClick={() => {
                                if (document.fullScreen || document.webkitIsFullScreen || document.mozFullScreen) {
                                    (
                                        document.exitFullScreen ||
                                        document.webkitExitFullscreen ||
                                        document.mozCancelFullScreen ||
                                        document.msExitFullScreen
                                    ).bind(document)();
                                }
                                else {
                                    (
                                        this.refs.content.requestFullScreen ||
                                        this.refs.content.webkitRequestFullScreen ||
                                        this.refs.content.mozRequestFullScreen ||
                                        this.refs.content.msRequestFullScreen
                                    ).bind(this.refs.content)();
                                }
                            }}>
                            <i className='fa-arrows-alt fa-lg'></i>
                        </button>
                        {(() => {
                            let type;
                            const tab = this.getTab(this.props);
                            switch (tab) {
                            case 'comments':
                                return <div
                                    style={{
                                        height: this.state.fullscreen ? undefined : `${this.props.height}em`,
                                        overflowY: 'auto',
                                        overflowX: 'hidden',
                                        paddingLeft: '3em',
                                        paddingRight: '3em',
                                        paddingTop: '1em',
                                    }}>
                                    <CommentList
                                        target={[
                                            currentExamination ? 'examination' : 'examination-catalogue',
                                            currentExamination ? currentExamination.id : this.state.data.id,
                                            'comment',
                                        ]}
                                        placeholder={window.gettext('Enter your review about this examination series...')}
                                        rates={[window.gettext('Rate 0'), window.gettext('Rate 1'), window.gettext('Rate 2'), window.gettext('Rate 3')]}
                                        commentStyle={{
                                            body: {
                                                height: '11.3em',
                                                overflowX: 'hidden',
                                                overflowY: 'auto',
                                                borderRadius: '3px',
                                                border: '.0625em solid #9a9a9a',
                                                padding: '1em',
                                            },
                                        }}
                                        formStyle={{
                                            body: {
                                                maxHeight: '13.3em',
                                            },
                                        }}
                                    />
                                </div>;
                            case 'problems':
                            case 'mistakes':
                                return <div
                                    style={{
                                        height: this.state.fullscreen ? undefined : `${this.props.height}em`,
                                        overflowY: 'auto',
                                        overflowX: 'hidden',
                                        paddingLeft: '8em',
                                        paddingRight: '8em',
                                        paddingTop: '1em',
                                    }}>
                                    <CommentList
                                        target={['examination', currentExamination.id, tab]}
                                        placeholder={tab === 'mistakes'
                                            ? window.gettext('Enter the mistake you found in examination...')
                                            : window.gettext('Describe the problem you experienced in examination executaion...')
                                        }
                                        submitMessage={window.gettext('We will examine the issue you reported!')}
                                        commentStyle={comment => comment.extra.accepted
                                            ? {
                                                box: {boxShadow: undefined, border: `.0625em solid ${styles.successColor}`},
                                                border: `.0625em solid ${styles.successBorderColor}`,
                                                header: {backgroundColor: styles.successBackColor/*, color: styles.sucessColor*/},
                                            }
                                            : comment.extra.accepted === false 
                                                ? {
                                                    box: {boxShadow: undefined, border: `.0625em solid ${styles.alertColor}`},
                                                    border: `.0625em solid ${styles.alertBorderColor}`,
                                                    header: {backgroundColor: styles.alertBackColor, color: styles.alertColor},
                                                }
                                                : undefined
                                        }
                                        bodyPreprocessor={body => body + '<div class="answer" style="font-size: calc(0.85 * 12pt);background-color: rgb(255, 225, 189);margin-bottom: 0.75em;padding-left: 0.5em;padding-right: 0.5em;color: rgb(40, 37, 99);width: 50%;">علامه حلی</div><p>جواب</p>'}
                                        actions={[
                                            {
                                                icon: comment => comment.extra.accepted
                                                    ? 'fa-check-circle'
                                                    : comment.extra.accepted === false
                                                        ? 'fa-times-circle'
                                                        : 'fa-info-circle',
                                                action: async (comment, props) => {
                                                    await this.context.store.dispatch(request({
                                                        path: `/comment/${comment.id}/`,
                                                        method: 'PATCH',
                                                        body: {extra: {
                                                            ...comment.extra,
                                                            accepted: comment.extra.accepted
                                                                ? false
                                                                : comment.extra.accepted === false
                                                                    ? null
                                                                    : true,
                                                        }},
                                                    }));
                                                    props.refresh();
                                                },
                                            },
                                        ]}
                                    />
                                </div>;
                            case 'results':
                                return <div
                                    style={{
                                        height: this.state.fullscreen ? '100%' : `${this.props.height}em`,
                                        overflowY: 'auto',
                                    }}>
                                    <span style={{fontSize: '.87em'}}>
                                        {this.props.children}
                                    </span>
                                </div>;
                            case 'preparation':
                                if (this.context.user.hasPerm('examination.edit'))
                                    return <div
                                        style={{
                                            height: this.state.fullscreen ? '100%' : `${this.props.height}em`,
                                            overflowY: 'auto',
                                            paddingTop: '.25em',
                                        }}>
                                        {window.gettext('ID')}:
                                        &nbsp;
                                        <input
                                            style={{...styles.field, width: undefined}}
                                            value={(currentExamination.preparation_examination || '').persian()}
                                            onChange={({target: {value}}) => {
                                                const updatedExamination = update(currentExamination, {
                                                    preparation_examination: {$set: value.english()},
                                                    modified: {$set: true},
                                                });
                                                this.setState(update(this.state, {data: {examinations: {
                                                    $splice: [[index, 1, updatedExamination]],
                                                }}}));
                                            }}
                                        />
                                        &nbsp;
                                        {window.gettext('Default')}: {currentExamination.default_preparation_examination}
                                    </div>;
                            case 'top_ranks':
                                return <div
                                    style={{
                                        height: this.state.fullscreen ? '100%' : `${this.props.height}em`,
                                        overflowY: 'auto',
                                    }}>
                                    {_.map(
                                        _.sortBy(currentExamination.topRanks, 'rank'), 
                                        row => <div>
                                            {row.rank.persian()}. {row.firstname} {row.lastname} -
                                            &nbsp;
                                            {row.school_name} - {row.city_name} - {row.region_name}
                                        </div>,
                                    )}
                                </div>;
                            case 'booklet':
                                return currentExamination && currentExamination.end_of_exam === true && currentExamination.analyze_date!=null && currentExamination.private_booklet === false ?
                                <span style={{userSelect: 'none'}}>
                                    <div
                                        style={{
                                            overflowY: 'auto',
                                            overflowX: 'hidden',
                                            height: 'calc(100% - 2.9em)',
                                            marginBottom: '.3em',
                                        }}>
                                        <Dialog
                                            isOpen={this.state.dialog}
                                            onClose={() => this.setState({dialog: false})}>
                                            <span>
                                                <div
                                                    style={{width: '18cm'}}
                                                    dangerouslySetInnerHTML={{
                                                        __html: this.state.dialogItem
                                                            ? this.state.view === 0
                                                                ? this.state.dialogItem.answer_content
                                                                : this.state.dialogItem.question_content
                                                            : '',
                                                    }}>
                                                </div>
                                                <br/>
                                                <div style={styles.dialogButtonContainer}>
                                                    <button
                                                        key='close'
                                                        style={styles.dialogButton}
                                                        onClick={() => this.setState({dialog: false})}>
                                                        {window.gettext('Close')}
                                                    </button>
                                                </div>
                                            </span>
                                            <span>{this.state.view === 0 ? window.gettext('Answer') : window.gettext('Question')}</span>
                                        </Dialog>
                                        {_.isArray(currentExamination.questions)
                                            ? <span style={{zoom: '1.13'}}>
                                                {renderExaminationPage(
                                                    currentExamination,
                                                    this.state.currentPage,
                                                    {
                                                        source: this.state.view,
                                                        complementary: item => <span
                                                            onClick={() => this.setState({dialog: true, dialogItem: item})}
                                                            style={{
                                                                position: 'absolute',
                                                                cursor: 'pointer',
                                                                top: '.2cm',
                                                                fontSize: '.85em',
                                                                color: 'blue',
                                                                [_.includes(item.content, 'english-ltr') ? 'right' : 'left']: '100%',
                                                                [_.includes(item.content, 'english-ltr') ? 'marginRight' : 'marginLeft']: '1mm',
                                                                transformOrigin: '0 100%',
                                                                transform: 'rotateZ(90deg)',
                                                                whiteSpace: 'nowrap',
                                                            }}>
                                                            {this.state.view === 0 ? window.gettext('Answer Text') : window.gettext('Question Text')}
                                                        </span>,
                                                    },
                                                )}
                                            </span>
                                            : null
                                        }
                                    </div>
                                    <div style={{textAlign: 'center'}}>
                                        <Button
                                            style={{...this.state.view === 0 ? styles.defaultButton : styles.button, padding: '0'}}
                                            onClick={() => this.setState({view: 0})}>
                                            {window.gettext('Questions')}
                                        </Button>
                                        &nbsp;
                                        <Button
                                            style={{...this.state.view === 1 ? styles.defaultButton : styles.button, padding: '0'}}
                                            onClick={() => this.setState({view: 1})}>
                                            {window.gettext('Answers')}
                                        </Button>
                                        &nbsp;
                                        <Button
                                            style={{
                                                opacity: this.state.currentPage > 0 ? undefined : '0',
                                                pointerEvents: this.state.currentPage > 0 ? undefined : 'none',
                                            }}
                                            onClick={() => this.setState({
                                                currentPage: this.state.currentPage - 1,
                                                index: this.state.currentPage,
                                            })}>
                                            <i className='fa-chevron-right'></i>
                                        </Button>
                                        <input
                                            style={{
                                                ...styles.field,
                                                width: '3em',
                                                display: 'inline-block',
                                                textAlign: 'center',
                                                marginBottom: undefined,
                                            }}
                                            value={this.state.index.persian()}
                                            onChange={({target: {value}}) => {
                                                const index = Number(value.english());
                                                if (
                                                    !value ||
                                                    index &&
                                                    index > 0 &&
                                                    index < pages
                                                )
                                                    this.setState({index});
                                            }}
                                            onKeyPress={event => {
                                                if ((event.keyCode || event.charCode) == 13)
                                                    this.setState({currentPage: this.state.index - 1});
                                            }}
                                        />
                                        <Button
                                            style={{
                                                opacity: this.state.currentPage < pages - 1 ? undefined : '0',
                                                pointerEvents: this.state.currentPage < pages - 1 ? undefined : 'none',
                                            }}
                                            onClick={() => this.setState({currentPage: this.state.currentPage + 1, index: this.state.currentPage + 2})}>
                                            <i className='fa-chevron-left'></i>
                                        </Button>
                                    </div>
                                </span> : <span> 
                                    دسترسی غیر مجاز</span>; 

                            case 'reports':
                            case 'budgets':
                                if (!type)
                                    type = 'pdf';
                            case 'virtual_content':
                                if (!type)
                                    type = 'video';
                                const item = this.props.params.examinationId === '0' ? this.state.data : _.find(
                                    this.state.data.examinations,
                                    examination => examination.id === Number(this.props.params.examinationId),
                                );
                                return <Folder
                                    data={_.find(item.folders, folder => folder.title === tab)}
                                    addFile={this.addFile.bind(this)}
                                    updateFile={this.updateFile.bind(this)}
                                    removeFile={this.removeFile.bind(this)}
                                    type={type}
                                    editable={this.context.user.hasPerm('examination.edit')}
                                    height={this.state.fullscreen ? '100%' : `${this.props.height}em`}
                                />;
                            default:
                                return <Content
                                    key='related_links'
                                    style={{
                                        ...styles.field,
                                        marginTop: '0',
                                        minHeight: '5em',
                                        overflowY: 'auto',
                                        overflowX: 'hidden',
                                        height: '100%',
                                        marginBottom: '.3em',
                                    }}
                                    inline
                                    tinymceConfig={{
                                        ...tinyMCEConfig,
                                        toolbar: [
                                            ...tinyMCEConfig.toolbar.slice(0, -1),
                                            tinyMCEConfig.toolbar.slice(-1)[0] + ' | toggle_position toggle_size line effects store_item',
                                        ],
                                    }}
                                    readonly={!this.context.user.hasPerm('examination.edit')}
                                    content={this.state.data.texts[(currentExamination
                                        ? currentExamination.id + ':'
                                        : ''
                                    ) + tab] || ''}
                                    onChange={content => this.setState(update(
                                        this.state,
                                        {data: {texts: {[(currentExamination
                                            ? currentExamination.id + ':'
                                            : ''
                                        ) + tab]: {$set: content}}}},
                                    ))}
                                />;
                            }
                        })()}
                    </div>
                </div>
            </div>
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <div
                    style={{
                        padding: '.375em',
                        marginTop: '2em',
                        overflow: 'hidden', 
                        // width: `${(11.7 + .52) * .8 * (this.props.params.examinationId === '0' ? 5 : 6)}em`,
                    }}>
                    {_.map(
                        this.props.params.examinationId === '0'
                            ? {
                                introduction: window.gettext('Examination Services'),
                                // reports: window.gettext('Different Reports'),//Maybe should remove
                                // pre_examination: window.gettext('Pre Examination'),
                                online_examination: window.gettext('Online Examination'),
                                // compilation_team: window.gettext('Compilation Team'),
                                study_resources: window.gettext('Study Resources'),
                                budgets: window.gettext('Examinations Budget'),
                                // advice: window.gettext('Advice'),
                                results: window.gettext('Examination Results'),
                                comments: window.gettext('Comments'),
                            }
                            : {
                                introduction: window.gettext('Examination Introduction'),
                                [currentExamination && currentExamination.end_of_exam === true  && currentExamination.analyze_date!=null && currentExamination.private_booklet === false ?'booklet':'booklet_']:window.gettext('Booklet'), 
                                // results: window.gettext('Examination Results'),
                                // online: window.gettext('Online'),
                                // preparation: window.gettext('Preparation Examination'), 
                                [currentExamination && currentExamination.first_question_count === 0?'top_ranks':'top_ranks_']:window.gettext('Top Ranks'), 
                                virtual_content: window.gettext('Virtual Content'),
                                // corrections: window.gettext('Corrections'),
                                // problems: window.gettext('Report Execution Problems'),  
                                // mistakes: window.gettext('Report Content Problems'),
                                comments: window.gettext('Comments'),  
                                [currentExamination && currentExamination.unrestricted_store_item?'purchase':'purchase_']:window.gettext('Purchase')
                            },
                        (text, id) => <div
                            key={id}
                            style={{
                                margin: '.25em',
                                background: `linear-gradient(${new Color(this.getTab(this.props) === id
                                    ? '#6B3904'
                                    : styles.primaryColor).lighten(1.4).hex()
                                }, ${new Color(this.getTab(this.props) === id
                                    ? '#6B3904'
                                    : styles.primaryColor).hex()
                                })`,
                                float: 'right',
                                borderRadius: '.6em',
                                fontSize: '.8em',
                                cursor: 'pointer',
                                ':active': {
                                    width: '18em',
                                },
                                ':hover': {
                                    width: '18em',
                                },
                            }}
                            onClick={() => {
                                if (id === 'purchase') {
                                    this.context.store.dispatch(addToCart({
                                        item: currentExamination.unrestricted_store_item,
                                        count: 1,
                                    }));
                                }
                                else if (id === 'results' && !currentExamination)
                                    this.context.store.dispatch(push('/reports/multiple-choice/'));
                                else if (id === 'online')
                                    this.context.store.dispatch(push(`/online-examinations/${currentExamination.id}/`));
                                else if (id === 'preparation' && !this.context.user.hasPerm('examination.edit'))
                                    this.context.store.dispatch(push(`/online-examinations/${currentExamination.preparation_examination}/`));
                                else if (!id.endsWith('_') || id.endsWith('__')) {
                                    this.context.store.dispatch(push(`/examination-catalogue/${this.props.params.catalogueId}/${this.props.params.examinationId}/${id.replace(/_*$/, '')}/`));
                                }
                            }}>
                            <div
                                style={{
                                    marginTop: '.2em',
                                    marginBottom: '.2em',
                                    width: '18em',
                                    borderRadius: '2.5em/.5em',
                                    background: `linear-gradient(${new Color(this.getTab(this.props) === id
                                        ? '#6B3904'
                                        : styles.primaryColor).lighten(.8).hex()},
                                    ${new Color(this.getTab(this.props) === id
        ? '#6B3904'
        : styles.primaryColor).lighten(.4).hex()})`,
                                }}>
                                <i
                                    style={{
                                        verticalAlign: 'middle',
                                        marginLeft: '.2em',
                                        marginRight: '.2em',
                                        paddingTop: '.15em',
                                        color: id.endsWith('_')
                                            ? styles.disabledColor
                                            : Radium.getState(this.state, id, ':hover')
                                                ? this.getTab(this.props) === id
                                                    ? styles.primaryColor
                                                    : styles.secondaryColor
                                                : 'white',
                                    }}
                                    className='fa-plus fa-2x'>
                                </i>
                                <button
                                    key={'button-' + id}
                                    style={{
                                        ..._.pickBy(this.getTab(this.props) === id
                                            ? styles.activeButton
                                            : styles.button, (value, key) =>
                                            !_.includes([
                                                'padding',
                                                'backgroundColor',
                                                'borderTop',
                                                'borderBottom',
                                                'borderLeft',
                                                'borderRight',
                                            ], key)),
                                        ':focus': undefined,
                                        fontSize: '1.2em',
                                        paddingTop: '.25em',
                                        paddingBottom: '.25em',
                                        whiteSpace: 'nowrap',
                                        width: '12.5em',
                                        color: id.endsWith('_')
                                            ? styles.disabledColor
                                            : Radium.getState(this.state, id, ':hover')
                                                ? this.getTab(this.props) === id ? styles.primaryColor : styles.secondaryColor
                                                : 'white',
                                        borderRadius: '.7em',
                                        border: 'none',
                                        boxShadow: `${new Color(this.getTab(this.props) === id ? '#6B3904' : styles.primaryColor).hex()}
                                        1px 1px 1px 0px,
                                        ${new Color(styles.primaryColor).hex()} -1px 1px 1px 0px`,
                                        background: !id.endsWith('_') && Radium.getState(this.state, id, ':active')
                                            ? `linear-gradient(
                                                ${new Color(this.getTab(this.props) === id ? '#6B3904' : styles.primaryColor).hex()},
                                                ${new Color(this.getTab(this.props) === id ? '#6B3904' : styles.primaryColor).lighten(1.2).hex()} 93%,
                                                ${new Color(this.getTab(this.props) === id ? '#6B3904' : styles.primaryColor).lighten(.5).hex()})`
                                            : `linear-gradient(
                                                ${new Color(this.getTab(this.props) === id ? '#6B3904' : styles.primaryColor).lighten(.5).hex()},
                                                ${new Color(this.getTab(this.props) === id ? '#6B3904' : styles.primaryColor).lighten(1.2).hex()} 7%,
                                                ${new Color(this.getTab(this.props) === id ? '#6B3904' : styles.primaryColor).hex()})`,
                                    }}>
                                    {text}
                                </button>
                            </div>
                        </div>,
                    )}
                </div>
            </div>
        </span>;
    }
}
